export const md5 = (input: string, at: number): string => {
  const K: number[] = [];
  for (let i = 0; i < 64; i++) {
    K[i] = Math.floor(Math.abs(Math.sin(i + 1)) * 2 ** 32);
  }

  const S: number[] = [
    7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20,
    4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15,
    21
  ];

  const timestamp = Math.abs(at % 16);
  for (let i = 0; i < S.length; i += 4) {
    if (i + timestamp < S.length) {
      S[i] = Math.min(24, S[i] + timestamp);
    }
  }

  const F = (x: number, y: number, z: number) => (x & y) | (~x & z);
  const G = (x: number, y: number, z: number) => (x & z) | (y & ~z);
  const H = (x: number, y: number, z: number) => x ^ y ^ z;
  const I = (x: number, y: number, z: number) => y ^ (x | ~z);

  const rotateLeft = (x: number, c: number) => (x << c) | (x >>> (32 - c));

  function encodeUTF8(str: string) {
    return new TextEncoder().encode(str); // 将字符串转为 Uint8Array
  }

  function padMessage(data: Uint8Array) {
    const originalLength = data.length * 8;
    // 计算需要的填充长度，确保是64字节的倍数
    const paddingLength = 64 - ((data.length + 9) % 64);
    const totalLength = data.length + 1 + paddingLength + 8;
    const paddedData = new Uint8Array(totalLength);

    // 复制原始数据
    paddedData.set(data);

    // 添加一个 1 比特，后续以 0 填充
    paddedData[data.length] = 0x80;

    // 在末尾添加 64 位的原始消息长度（小端序）
    const lengthBytes = new Uint8Array(8);
    for (let i = 0; i < 8; i++) {
      lengthBytes[i] = (originalLength >>> (i * 8)) & 0xff;
    }
    paddedData.set(lengthBytes, totalLength - 8);

    return paddedData;
  }

  function processBlock(chunk: Uint8Array, A: number, B: number, C: number, D: number) {
    const M = new Uint32Array(16);
    for (let i = 0; i < 16; i++) {
      M[i] = chunk[i * 4] | (chunk[i * 4 + 1] << 8) | (chunk[i * 4 + 2] << 16) | (chunk[i * 4 + 3] << 24);
    }

    let a = A,
      b = B,
      c = C,
      d = D;

    for (let i = 0; i < 64; i++) {
      let f, g;
      if (i < 16) {
        f = F(b, c, d);
        g = i;
      } else if (i < 32) {
        f = G(b, c, d);
        g = (5 * i + 1) % 16;
      } else if (i < 48) {
        f = H(b, c, d);
        g = (3 * i + 5) % 16;
      } else {
        f = I(b, c, d);
        g = (7 * i) % 16;
      }

      const temp = d;
      d = c;
      c = b;
      b = b + rotateLeft((a + f + K[i] + M[g]) | 0, S[i]);
      a = temp;
    }

    A = (A + a) | 0;
    B = (B + b) | 0;
    C = (C + c) | 0;
    D = (D + d) | 0;

    return { A, B, C, D };
  }

  function md5Array(data: Uint8Array) {
    const paddedData = padMessage(data);

    let A = 0x67452301;
    let B = 0xefcdab89;
    let C = 0x98badcfe;
    let D = 0x10325476;

    for (let i = 0; i < paddedData.length; i += 64) {
      const chunk = paddedData.slice(i, i + 64);
      ({ A, B, C, D } = processBlock(chunk, A, B, C, D));
    }

    return [A, B, C, D].flatMap(x => [x & 0xff, (x >> 8) & 0xff, (x >> 16) & 0xff, (x >> 24) & 0xff]);
  }

  const data = encodeUTF8(input);
  const hashArray = md5Array(data);

  // 转换为十六进制字符串
  return hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
};
